export default function ClearSortingIcon() {
    return (
        <img
            src="assets/images/icons/clear_sorting_outward_arrows.svg"
            alt="Clear Sorting"
        />
    )
}
